var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 540,
    viewBox: "0 0 396 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M626.368 471.794C262.183 455.222 113.09 415.794 -139.859 225.586C-392.808 35.3784 -233.38 516.636 -233.38 516.636L532.847 762.844C532.847 762.844 990.554 488.366 626.368 471.794Z",
    fill: "#3874FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M434.557 642.732C175.65 454.23 87.5518 352.274 5.68647 85.6643C-76.1788 -180.945 -222.686 261.482 -222.686 261.482L206.185 818.549C206.185 818.549 693.464 831.233 434.557 642.732Z",
    fill: "#3874FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.8d2471b100c1aef1d8aea1d2af86ecf5.svg";
export { ForwardRef as ReactComponent };